import { useContext, useEffect, useRef, useState } from "react";
import Contexts from "../contexts/Contexts";
import { Snackbar, Typography } from "@mui/joy";

const GlobalMessage = () => {
  const { globalMessage, globalMessageColor, setGlobalMessage, globalMessageAction, setGlobalMessageAction } = useContext(Contexts);
  const [open, setOpen] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (globalMessage) {
      setOpen(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setOpen(false);
        setGlobalMessage("");
        setGlobalMessageAction(null);
        timerRef.current = null;
      }, 5000);
    } else {
      setOpen(false);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reacts to globalMessage changes; context setters are stable, not triggers
  }, [globalMessage]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setGlobalMessage("");
    setGlobalMessageAction(null);
  };

  const handleSnackbarClick = () => {
    if (globalMessageAction) {
      globalMessageAction();
      handleClose();
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      variant="soft"
      color={globalMessageColor}
      onClose={handleClose}
      onClick={globalMessageAction ? handleSnackbarClick : undefined}
      sx={{
        boxShadow: "lg",
        borderRadius: "md",
        zIndex: 9999,
        cursor: globalMessageAction ? "pointer" : "default",
      }}
    >
      <div>
        <Typography level="body-sm" sx={{ mt: 0.5 }}>
          {globalMessage}
        </Typography>
      </div>
    </Snackbar>
  );
};

export default GlobalMessage;
